import { gql } from '@apollo/client';

import { StudentAssignmentsActivity } from '@ts-core/modules/billing/types';

export interface GetStudentAssignmentsByMonthQueryVariables {
  courseId: string;
  studentId: string;
  year: string;
  month: string;
}

export interface GetStudentAssignmentsByMonthQueryResult {
  assignments: StudentAssignmentsActivity[];
}

export const getStudentAssignmentsByMonthQuery = gql`
  query GetStudentAssignmentsByMonthQuery($courseId: String!, $studentId: String!, $year: String!, $month: String!) {
    assignments(courseId: $courseId, studentId: $studentId, year: $year, month: $month)
      @rest(
        type: "StudentAssignmentsActivityByMonth"
        path: "students-activity/years/{args.year}/months/{args.month}/courses/{args.courseId}/students/{args.studentId}/assignments"
      ) {
      _id
      name
      answerId
      answerStartDate
      answerFinishDate
      score
    }
  }
`;
